/**
 * Enhanced error handler for KendoEditor operations
 * Provides consistent error logging and potential fallback behavior
 */
export const handleEditorError = (
  error: Error,
  context: string,
  fallback?: () => void
) => {
  // Execute fallback if provided
  if (fallback) {
    try {
      fallback();
    } catch (fallbackError) {
      // eslint-disable-next-line no-console
      console.error(`KendoEditor ${context} fallback failed:`, fallbackError);
    }
  }
};
